var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbuttonAppointmentform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "back button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Video-Visit---Appointment-form-01.1",
    transform: "translate(-25.000000, -263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_black_24dp-2",
    transform: "translate(25.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#5571C6",
    fillRule: "nonzero",
    points: "16.6666667 9.16666667 6.525 9.16666667 11.1833333 4.50833333 10 3.33333333 3.33333333 10 10 16.6666667 11.175 15.4916667 6.525 10.8333333 16.6666667 10.8333333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbuttonAppointmentform);
export default __webpack_public_path__ + "static/media/back button_appointment form.4877a3c437fb56a0c657de46549b25e5.svg";
export { ForwardRef as ReactComponent };